/* global axios */
import ApiClient from './ApiClient';

class TalkviaConnectedBankQueriesAPI extends ApiClient {
  constructor() {
    super('talkvia_connected_bank_queries', { accountScoped: true });
  }

  get(params) {
    return params ? axios.get(this.url, { params }) : axios.get(this.url);
  }

  providers() {
    return axios.get(`${this.url}/providers`);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  deleteByCpf(cpf) {
    return axios.delete(`${this.url}/by_cpf`, { data: { cpf } });
  }

  continueResult(batchId, resultId, data) {
    return axios.post(`${this.url}/${batchId}/results/${resultId}/continue`, {
      data,
    });
  }

  retryResult(batchId, resultId) {
    return axios.post(`${this.url}/${batchId}/results/${resultId}/retry`);
  }
}

export default new TalkviaConnectedBankQueriesAPI();
